import { useRouter } from 'next/router';
import { Dispatch, SetStateAction, memo } from 'react';
import styles from './FilterMenu.module.scss';
import Box from '@/components/UI/box/Box';
import DatePicker from './datePicker/DatePicker';
import GuestCount from './guestCount/GuestCount';
import PriceRange from './priceRange/PriceRange';
import HouseType from './houseType/HouseType';
import MoreFilters from './moreFilters/MoreFilters';
import MapSwitch from './mapSwitch/MapSwitch';
import useDevice from '@/hooks/useDevice';
import MidTermFeature from './midTermFeature/MidTermFeature';
import MidTermNeighbourhoods from './midTermNeighbourhoods/MidTermNeighbourhoods';
import MidTermMoreFilters from './midTermMoreFilters/MidTermMoreFilters';
import MidTermPriceRange from './midTermPriceRange/MidTermPriceRange';
import Installment from '@/components/search/filters/filtersMenu/installment/Installment';
const defaultFilters = [{
  component: <DatePicker />
}, {
  component: <GuestCount />
}, {
  component: <MoreFilters />
}, {
  component: <PriceRange />
}, {
  component: <HouseType />
}];
const MidTermFilterItems = [{
  component: <DatePicker />
}, {
  component: <MidTermNeighbourhoods />
}, {
  component: <MidTermPriceRange />
}, {
  component: <MidTermFeature />
}, {
  component: <MidTermMoreFilters />
}];
const snappFilterItem = {
  component: <Installment />
};
interface FilterMenuProps {
  isShowMap: boolean;
  setIsShowMap: Dispatch<SetStateAction<boolean>>;
  setMapFullscreen: Dispatch<SetStateAction<boolean>>;
}
const FiltersMenu = (props: FilterMenuProps) => {
  const {
    isMobile
  } = useDevice();
  const router = useRouter();
  const filters = [...defaultFilters];
  if (router?.query?.installment_payment) {
    filters.splice(1, 0, snappFilterItem);
  }
  return <Box className={styles['filters-menu-container']} data-sentry-element="Box" data-sentry-component="FiltersMenu" data-sentry-source-file="FiltersMenu.tsx">
      <Box className={styles['filter-container']} data-sentry-element="Box" data-sentry-source-file="FiltersMenu.tsx">
        <Box component="ul" className={styles['filter-items-container']} data-sentry-element="Box" data-sentry-source-file="FiltersMenu.tsx">
          {router.query.mid_term ? MidTermFilterItems.map((item, index) => <li key={index} className={styles['filter-item']}>
                  {item.component}
                </li>) : filters.map((item, index) => <li key={index} className={styles['filter-item']}>
                  {item.component}
                </li>)}
        </Box>
        {!isMobile && <Box>
            <MapSwitch isShowMap={props.isShowMap} setIsShowMap={props.setIsShowMap} setMapFullscreen={props.setMapFullscreen} />
          </Box>}
      </Box>
    </Box>;
};
export default memo(FiltersMenu);